import { CrudBuilderState } from "seneca-common/utils/apiStates";

import TeacherAssignmentsMetaState from "../../../models/TeacherAssignmentsMetaState";

export function getClassAssignmentsMetaState(
  metaState: TeacherAssignmentsMetaState
): CrudBuilderState {
  return metaState.futureAssignments as CrudBuilderState;
}

export function getAllClassAssignmentsMetaState(
  metaState: TeacherAssignmentsMetaState
): CrudBuilderState {
  return metaState.pastAssignments as CrudBuilderState;
}

export function getCrudMetaState(
  metaState: TeacherAssignmentsMetaState
): CrudBuilderState {
  return metaState.individualAssignments as CrudBuilderState;
}
